<script>
import {ref} from "vue";
import {useRoute} from "vue-router";
import VOtpInput from "vue3-otp-input";
import {useTimer} from "vue-timer-hook";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import router from "@/router";
import {useStore} from "vuex";
import useClipboard from "vue-clipboard3";

export default {
  name: "OtpPage",
  components:{VOtpInput},
  setup() {

    let store = useStore()
    let loading = ref(false)
    let data = ref({
      phone: useRoute().params.phone,
      otp:'',
    })
    let uid = null


    const time = new Date();
    time.setSeconds(time.getSeconds() + 50); // 10 minutes timer
    const timer = useTimer(time);

    function send_code() {

      loading.value = true
      FreeWorld.Heisenberg(data.value , 'otp').then((res)=>{

        loading.value = false
        if (res.data.status == 'ok'){
          if (res.data.event == 'user_exist'){
            let id = FreeWorld.PinkMan(res.data.uid , 'en')
            uid = res.data.uid
            localStorage.setItem('uid' , id)
            run_app()
          }else{
            router.push({name:'RegisterPage',params:{phone:data.value.phone}})
          }
        }else if(res.data.event == 'code wrong'){
          Swals.Fault('کد وارد شده صحیح نمیباشد')
        }else (
            Swals.Fault('لطفا مجددا تلاش فرماید')
        )

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , send_code)
      })

    }
    function run_app() {
      loading.value = true

          FreeWorld.Heisenberg({action: 'addresses', uid:uid}, 'info').then((res) => {

            store.commit('set_address', res.data)

              FreeWorld.Heisenberg({action: 'cards', uid:uid}, 'info').then((res) => {

                store.commit('set_Card', res.data.cards)

                FreeWorld.Heisenberg({action: 'profile', uid:uid}, 'info').then((res) => {

                  store.commit('set_profile', res.data)

                    loading.value = false
                    window.location.href = "/HomePage"

                }).catch((res) => {
                  loading.value = false
                  Swals.Catch(res, run_app, true)
                })

              }).catch((res) => {
                loading.value = false
                Swals.Catch(res, run_app, true)
              })

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, run_app, true)
          })

    }
    function try_code() {

      const time = new Date();
      time.setSeconds(time.getSeconds() + 50); // 10 minutes timer
      timer.restart(time);

      let x = {phone: data.value.phone}

      FreeWorld.Heisenberg(x , 'phone').then((result)=>{

        if (result.data.status == 'ok'){
          Swals.Done('پیامک ارسال گردید')
        }

      }).catch((result)=>{

        Swals.Catch(result , try_code)

      })

    }


    let showSupport = ref(true)

    function hideSupportCall() {
      showSupport.value = false;
    }

    function showSupportCall() {
      showSupport.value = true;
    }

    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.info.phone
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }


    return {

      loading,
      data,
      send_code,
      timer,
      try_code,
      call_support,
      showSupport,
      hideSupportCall,
      showSupportCall,

    }
  }
}
</script>


<template>

  <div id="main" :class="loading ? 'pe-none':'' " class="">

    <img class="patch position-absolute max_width top-0" src="../assets/img/Path.png" alt="">

    <div class="d-flex justify-content-center mt-5">
      <img class="position-relative img_logo" src="../assets/img/logo.png" alt="">
    </div>

    <div class="p-body position-relative w-100 mt-3">
      <div class="rounded-4 shadow-custom py-5 w-100 p-body filter_blur">
        <p class="font-4 text-center text-white font-bold mb-5">کد ارسال را وارد کنید</p>

        <div dir="ltr" class="">
          <v-otp-input
              class="w-100 justify-content-center align-items-center"
              v-model:value="data.otp"
              input-classes="input_otp bg-white mx-2 text-center p-2 rounded-pill"
              :num-inputs="4"
              separator=" "
              :placeholder="['', '', '', '']"
              :should-auto-focus="true"
              input-type="letter-numeric"
              :conditionalClass="['one', 'two', 'three', 'four']"
              @on-complete="send_code"
              @focusin="hideSupportCall" @focusout="showSupportCall"
          />
        </div>

        <p class="text-center my-2 font-4 text-white">00:{{ timer.seconds }}</p>

        <div class="d-flex align-items-center justify-content-evenly">
          <router-link to="/LoginPage" class="text-white">ویرایش شماره</router-link>
          <p @click="try_code" v-if="timer.isExpired.value" href="#" class="text-white">ارسال مجدد</p>
        </div>

        <div style="margin-top: 10vh" class="w-100 d-flex justify-content-center">
          <v-btn @click="send_code" :loading="loading" class="bg-color-light h-100 shadow-custom rounded-3 py-3 w-70">ثبت</v-btn>
        </div>
      </div>
    </div>

    <div v-show="showSupport" id="support_call" class="position-fixed max_width w-100 bottom-0">
      <div @click="call_support"
           style="width: 10rem" class="bg-color p-1 shadow-custom rounded-pill d-flex align-items-center mr-3 mb-3">
        <img class="icon-size-5" src="../assets/img/icon_phon_liner.svg" alt="">
        <p class="font-4 text-white mr-3">پشتیبانی</p>
      </div>
    </div>

  </div>

</template>


<style scoped>

.patch {
  width: 101%;
  height: 700px;
}

.icon_phone {
  right: 0;
  width: 55px;
  height: 55px;
  top: 54%;
  transform: translate(0, -52%);
}

.filter_blur {
  backdrop-filter: saturate(1) blur(15px);
  -webkit-backdrop-filter: blur(10px);
  background-color: #f0f8ff1c;
}

.img_logo {
  height: 250px;
}

</style>